export function isFalsy(value: 0 | 1 | false) {
    return value == false;
}
